// src/LandingPage.js - Professional Single-Screen Design
import React from 'react';
import { useUser, useClerk } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';  // ADD THIS LINE


const LandingPage = () => {
  const { user } = useUser();
  const { openSignIn } = useClerk();
  const navigate = useNavigate();

  const handleGetStarted = () => {
    if (user) {
      navigate('/calculator-suite');
    } else {
      openSignIn();
    }
  };

  const handleLogin = () => {
    if (user) {
      navigate('/calculator-suite');
    } else {
      openSignIn();
    }
  };

return (
  <div style={{
    height: '100vh',
    background: 'linear-gradient(135deg, #157DEC 0%, #1054a8 100%)',
    padding: '0', // Changed from '15px'
    fontFamily: 'Century Gothic, sans-serif',
    display: 'flex',
    flexDirection: 'column'
  }}>
    <div style={{ 
      maxWidth: '1200px', 
      margin: '0 auto',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-evenly', // Changed from 'flex-start'
      gap: '10px', // Reduced from '15px'
      padding: '15px' // Moved padding here instead
    }}>
        
        {/* Header Section - Reasonable Size */}
        <div style={{
          background: 'white',
          padding: '20px 35px',
          borderRadius: '10px',
          border: '5px solid black',
          textAlign: 'center',
          boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
        }}>
          
          {/* Buttons and Logo Layout */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '10px'
          }}>
            {/* Left Spacer */}
            <div style={{ width: '140px' }}></div>

            {/* Centered Logo */}
            <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', zIndex: 1 }}>
              <svg 
                viewBox="0 0 360 90" 
                xmlns="http://www.w3.org/2000/svg"
                style={{ width: '661px', height: '166px' }}
              >
                <defs>
                  <linearGradient id="brandBlue" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style={{stopColor:'#157DEC', stopOpacity:1}} />
                    <stop offset="100%" style={{stopColor:'#1054a8', stopOpacity:1}} />
                  </linearGradient>
                  <linearGradient id="accentBlue" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style={{stopColor:'#1054a8', stopOpacity:1}} />
                    <stop offset="100%" style={{stopColor:'#0c4389', stopOpacity:1}} />
                  </linearGradient>
                  <linearGradient id="lightBlue" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style={{stopColor:'#3b94f0', stopOpacity:1}} />
                    <stop offset="100%" style={{stopColor:'#157DEC', stopOpacity:1}} />
                  </linearGradient>
                  
                  <filter id="energyGlow" x="-50%" y="-50%" width="200%" height="200%">
                    <feGaussianBlur stdDeviation="4" result="coloredBlur"/>
                    <feMerge> 
                      <feMergeNode in="coloredBlur"/>
                      <feMergeNode in="SourceGraphic"/>
                    </feMerge>
                  </filter>
                  
                  <filter id="sharpShadow" x="-20%" y="-20%" width="140%" height="140%">
                    <feDropShadow dx="3" dy="3" stdDeviation="0" floodColor="rgba(0,0,0,0.25)"/>
                  </filter>
                </defs>
                
                <path d="M 15 15 L 65 25 L 55 65 L 25 55 Z" fill="url(#brandBlue)" opacity="0.08" transform="rotate(12 40 40)"/>
                <circle cx="50" cy="50" r="25" fill="url(#lightBlue)" opacity="0.05"/>
                
                <g transform="translate(20, 22) skewX(-8)" filter="url(#sharpShadow)">
                  <rect x="6" y="16" width="26" height="20" fill="url(#brandBlue)" rx="3"/>
                  <path d="M 19 6 L 4 16 L 34 16 Z" fill="url(#accentBlue)"/>
                  <rect x="12" y="26" width="7" height="10" fill="#ffffff" rx="2"/>
                  <circle cx="17" cy="31" r="1.2" fill="url(#lightBlue)"/>
                  <rect x="22" y="20" width="7" height="5" fill="#ffffff" rx="1"/>
                  <rect x="8" y="20" width="4" height="4" fill="#ffffff" rx="1"/>
                  <path d="M 19 8 L 15 12 L 23 12 Z" fill="#ffffff" opacity="0.9"/>
                </g>
                
                <g transform="translate(50, 28) skewX(5)" filter="url(#energyGlow)">
                  <rect x="0" y="0" width="20" height="26" fill="url(#lightBlue)" rx="4"/>
                  <rect x="2" y="2" width="16" height="7" fill="#000000" rx="2"/>
                  <text x="10" y="7" textAnchor="middle" fill="#157DEC" fontFamily="JetBrains Mono, monospace" fontSize="3.5" fontWeight="700">+18.2%</text>
                  
                  <g fill="#ffffff">
                    <rect x="3" y="11" width="3" height="2.5" rx="0.5"/>
                    <rect x="7" y="11" width="3" height="2.5" rx="0.5"/>
                    <rect x="11" y="11" width="3" height="2.5" rx="0.5"/>
                    <rect x="15" y="11" width="3" height="2.5" rx="0.5" fill="url(#accentBlue)"/>
                    
                    <rect x="3" y="14.5" width="3" height="2.5" rx="0.5"/>
                    <rect x="7" y="14.5" width="3" height="2.5" rx="0.5"/>
                    <rect x="11" y="14.5" width="3" height="2.5" rx="0.5"/>
                    <rect x="15" y="14.5" width="3" height="2.5" rx="0.5" fill="url(#accentBlue)"/>
                    
                    <rect x="3" y="18" width="3" height="2.5" rx="0.5"/>
                    <rect x="7" y="18" width="3" height="2.5" rx="0.5"/>
                    <rect x="11" y="18" width="3" height="2.5" rx="0.5"/>
                    <rect x="15" y="18" width="3" height="5" rx="0.5" fill="url(#brandBlue)"/>
                    
                    <rect x="3" y="21.5" width="7" height="2.5" rx="0.5"/>
                    <rect x="11" y="21.5" width="3" height="2.5" rx="0.5"/>
                  </g>
                  
                  <circle cx="17" cy="3.5" r="1" fill="url(#brandBlue)" opacity="0.9"/>
                </g>
                
                <g transform="translate(-5, 0)">
                  <g transform="translate(95, 0)">
                    <text x="0" y="22" fontFamily="Poppins, system-ui, sans-serif" fontSize="20" fontWeight="800" fill="#1f2937">
                      <tspan fill="url(#brandBlue)">The Buy</tspan><tspan fill="url(#brandBlue)"> to </tspan><tspan fill="url(#brandBlue)">Let</tspan>
                    </text>
                    <text x="0" y="44" fontFamily="Poppins, system-ui, sans-serif" fontSize="20" fontWeight="800" fill="#1f2937">
                      Calculator <tspan fill="url(#brandBlue)">Company</tspan>
                    </text>
                    
                    <text x="0" y="63" fontFamily="Inter, system-ui, sans-serif" fontSize="9" fontWeight="500" fontStyle="italic" fill="url(#brandBlue)" letterSpacing="0.5px">
                      Affordability Guidance for Brokers
                    </text>
                    
                    <rect x="0" y="68" width="60" height="2" fill="url(#brandBlue)" rx="1" opacity="0.7"/>
                  </g>
                </g>
                
                <g opacity="0.6">
                  <path d="M 320 20 L 330 15 L 340 25 L 325 30 Z" fill="url(#accentBlue)"/>
                  <circle cx="315" cy="60" r="4" fill="url(#lightBlue)"/>
                  <rect x="330" y="70" width="8" height="8" fill="url(#brandBlue)" rx="2" transform="rotate(25 334 74)"/>
                </g>
                
                <path d="M 280 30 Q 290 25 300 30" stroke="url(#brandBlue)" strokeWidth="1.5" fill="none" opacity="0.4"/>
                <path d="M 285 65 Q 295 60 305 65" stroke="url(#accentBlue)" strokeWidth="1" fill="none" opacity="0.5"/>
              </svg>
            </div>

            {/* Right Button Stack */}
            <div style={{ 
              display: 'flex', 
              flexDirection: 'column',
              gap: '8px',
              width: '140px'
            }}>
              <button 
                onClick={handleLogin}
                style={{
                  padding: '8px 12px',
                  fontSize: '12px',
                  background: 'white',
                  color: '#157DEC',
                  border: '2px solid black',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  width: '100%',
                  whiteSpace: 'nowrap'
                }}
              >
                Existing Users Login
              </button>
              
              <button 
                onClick={handleGetStarted}
                style={{
                  padding: '8px 12px',
                  fontSize: '12px',
                  background: '#157DEC',
                  color: 'white',
                  border: '2px solid black',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  width: '100%'
                }}
              >
                Sign Up Now
              </button>
              
              {/* WhatsApp Contact */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
                marginTop: '8px'
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488" fill="#25D366"/>
                </svg>
                <a 
                  href="https://wa.me/447874401497"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ 
                    color: '#4a5568', 
                    fontSize: '14px',
                    fontWeight: 'bold',
                    textDecoration: 'none'
                  }}
                >
                  07874 401497
                </a>
              </div>
            </div>
          </div>

{/* Subtitle - Updated */}
<p style={{
  fontSize: '20px',
  color: 'black',
  fontWeight: 'bold',
  margin: 0,
  position: 'relative',
  zIndex: 2,
  textAlign: 'center'
}}>
  For the First Time, Brokers Can Now Instantly Compare Multiple Lenders' Affordability<br />
  Calculations Across SPV and Individual Products <em style={{ color: '#157DEC', fontSize: '14px' }}>- with calculators for Portfolio & HMO coming soon</em>
</p>
        </div>

        {/* Three Feature Boxes - Single Row */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '15px'
        }}>
          
          <div style={{
            background: 'white',
            padding: '15px',
            borderRadius: '8px',
            border: '3px solid black',
            textAlign: 'center',
            boxShadow: '0 5px 20px rgba(0,0,0,0.2)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '85px'
          }}>
            <h3 style={{ 
              fontSize: '1.1rem', 
              fontWeight: 'bold', 
              marginBottom: '6px',
              color: '#157DEC',
              margin: '0 0 6px 0'
            }}>
              Instant Results
            </h3>
            <p style={{ 
              fontSize: '0.9rem', 
              lineHeight: '1.3',
              color: '#4a5568',
              margin: 0,
              textAlign: 'center'
            }}>
              Get immediate calculations to speed up client consultations, providing not just the figures you need, but potential maximum borrowing too
            </p>
          </div>

          <div style={{
            background: 'white',
            padding: '15px',
            borderRadius: '8px',
            border: '3px solid black',
            textAlign: 'center',
            boxShadow: '0 5px 20px rgba(0,0,0,0.2)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '85px'
          }}>
            <h3 style={{ 
              fontSize: '1.1rem', 
              fontWeight: 'bold', 
              marginBottom: '6px',
              color: '#157DEC',
              margin: '0 0 6px 0'
            }}>
              Accurate Calculations
            </h3>
            <p style={{ 
              fontSize: '0.9rem', 
              lineHeight: '1.3',
              color: '#4a5568',
              margin: 0,
              textAlign: 'center'
            }}>
              Comprehensive affordability assessments that account for rental income, stress testing, and lender criteria variations, across both standard and SPV product ranges
            </p>
          </div>

          <div style={{
            background: 'white',
            padding: '15px',
            borderRadius: '8px',
            border: '3px solid black',
            textAlign: 'center',
            boxShadow: '0 5px 20px rgba(0,0,0,0.2)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '85px'
          }}>
            <h3 style={{ 
              fontSize: '1.1rem', 
              fontWeight: 'bold', 
              marginBottom: '6px',
              color: '#157DEC',
              margin: '0 0 6px 0'
            }}>
              Broker Focused
            </h3>
            <p style={{ 
              fontSize: '0.9rem', 
              lineHeight: '1.3',
              color: '#4a5568',
              margin: 0,
              textAlign: 'center'
            }}>
              Designed by mortgage brokers <span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>exclusively</span> for mortgage brokers, with features that match your workflow and client needs
            </p>
          </div>
        </div>

        {/* Combined CTA and Action Buttons Section */}
        <div style={{
          background: 'white',
          padding: '20px',
          borderRadius: '8px',
          border: '3px solid black',
          textAlign: 'center',
          boxShadow: '0 5px 20px rgba(0,0,0,0.2)'
        }}>
          <h3 style={{ 
            fontSize: '17px', 
            fontWeight: 'bold', 
            marginBottom: '6px',
            marginTop: '-8px',
            color: '#2d3748'
          }}>
            Everything You Need To Provide Accurate Buy-To-Let Affordability Guidance Assessments For Your Clients
          </h3>
          <p style={{ 
            fontSize: '0.95rem', 
            color: '#4a5568',
            marginBottom: '12px'
          }}>
            Click Below to See <strong>How It Works</strong>, or <strong>Sign Up Now</strong>, with a Money Back Guarantee 
          </p>

          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '15px',
            flexWrap: 'wrap',
            marginBottom: '12px'
          }}>
            <button 
             onClick={() => navigate('/how-it-works')}
              style={{
                padding: '12px 24px',
                fontSize: '14px',
                background: '#157DEC',
                color: 'white',
                border: '2px solid black',
                borderRadius: '5px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              How It Works
            </button>
            <button 
              onClick={() => navigate('/pricing')}
              style={{
                padding: '12px 24px',
                fontSize: '14px',
                background: 'white',
                color: '#157DEC',
                border: '2px solid black',
                borderRadius: '5px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              Pricing
            </button>
            <button 
              onClick={handleGetStarted}
              style={{
                padding: '12px 24px',
                fontSize: '14px',
                background: '#157DEC',
                color: 'white',
                border: '2px solid black',
                borderRadius: '5px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              Sign Up Now
            </button>
            <button 
              onClick={handleLogin}
              style={{
                padding: '12px 24px',
                fontSize: '14px',
                background: 'white',
                color: '#157DEC',
                border: '2px solid black',
                borderRadius: '5px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              Login
            </button>
          </div>

          <p style={{ 
            fontSize: '0.75rem', 
            color: '#4a5568',
            margin: '0'
          }}>
            The Buy To Let Calculator Company Ltd Act on a Non-Advisory, Information-Only Basis and The Calculators do not Provide any Financial Advice
          </p>
        </div>

        {/* Footer Links - Outside boxes with white text */}
        <div style={{
          textAlign: 'center'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '20px',
            marginBottom: '5px'
          }}>
            <a href="/Privacy Policy (August 2025).pdf" target="_blank" rel="noopener noreferrer" style={{ color: 'white', textDecoration: 'underline', fontSize: '0.85rem' }}>Privacy Policy</a>
            <a href="/Terms and Conditions (August 2025).pdf" target="_blank" rel="noopener noreferrer" style={{ color: 'white', textDecoration: 'underline', fontSize: '0.85rem' }}>T's and C's</a>
            <a href="/Cookies Policy (August 2025).pdf" target="_blank" rel="noopener noreferrer" style={{ color: 'white', textDecoration: 'underline', fontSize: '0.85rem' }}>Cookies Policy</a>
            <a href="https://wa.me/447874401497" target="_blank" rel="noopener noreferrer" style={{ color: 'white', textDecoration: 'underline', fontSize: '0.85rem' }}>Contact</a>
            <a href="mailto:support@btlcc.co.uk" style={{ color: 'white', textDecoration: 'underline', fontSize: '0.85rem' }}>Support</a>
          </div>
          <p style={{ 
            color: 'white', 
            fontSize: '0.8rem',
            margin: '0 0 3px 0'
          }}>
            © 2025 The Buy to Let Calculator Company Ltd. All rights reserved.
          </p>
          <p style={{ 
            color: 'white', 
            fontSize: '0.65rem',
            margin: 0,
            whiteSpace: 'nowrap'
          }}>
            Registered in England & Wales (Company No: 16671121). Registered Office: 73 Barton St, GL20 5PY. ICO Registration No: ZB971476.
          </p>
        </div>

      </div>
    </div>
  );
};

export default LandingPage;